import { Button, IconButton, TextField, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { Formik, Form, ErrorMessage, Field } from 'formik';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
import { BiEdit } from 'react-icons/bi';
import { DataGrid, GridDeleteForeverIcon } from '@mui/x-data-grid';
import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import dayjs from 'dayjs';
import {
  deleteHoliday,
  getHolidaysList,
  postHoliday,
  updateHoliday,
} from '../../features/attendance/AttendanceSlice';

const HolidaysPage = () => {
  const { userDetails } = useSelector((state) => state.auth?.successData);
  const [holidays, setHolidays] = useState([]);
  const [holidayInfo, setHolidayInfo] = useState();
  async function getHolidays() {
    const response = await dispatch(getHolidaysList()).unwrap();
    setHolidays(response);
  }
  useEffect(() => {
    getHolidays();
  }, []);
  const columns = [
    {
      field: 'holidayDate',
      headerAlign: 'center',
      headerName: (
        <Typography variant='body2' className='text-center font-bold'>
          Date
        </Typography>
      ),
      minwidth: '130px',
      flex: 0.3,
      renderCell: (params) => (
        <p className='text-center font-semibold  '>
          {dayjs(params.value).format('DD-MM-YYYY')}
        </p>
      ),
    },
    {
      field: 'description',
      renderCell: (params) => (
        <p className='truncate px-2' style={{ fontSize: '15px' }}>
          {params.value}
        </p>
      ),
      headerName: (
        <Typography variant='body2' className='text-center font-bold'>
          Event
        </Typography>
      ),
      flex: 1,
      sortable: false,
    },
    {
      field: 'Actions',
      headerAlign: 'center',
      headerName: (
        <Typography variant='body2' className='text-center font-bold'>
          Action
        </Typography>
      ),
      minwidth: '100px',
      flex: 0.3,
      renderCell: (params) => (
        <div className='flex py-2 gap-2 justify-center'>
          <IconButton
            size='small'
            className='text-blue-500 bg-blue-100 rounded'
            variant='outlined'
            onClick={() => {
              setHolidayInfo(params.row);
            }}
          >
            <BiEdit />
          </IconButton>

          <IconButton
            size='small'
            className='text-red-400 bg-red-100 rounded'
            variant='outlined'
            onClick={async () => {
              const result = await dispatch(
                deleteHoliday(params.row.id),
              ).unwrap();
              if (!result) {
                alert('Error in Deletion');
              } else {
                getHolidays();
              }
            }}
          >
            <GridDeleteForeverIcon />
          </IconButton>
        </div>
      ),
      sortable: false,
    },
  ];
  const dispatch = useDispatch();
  return (
    <>
      <Formik
        enableReinitialize
        initialValues={
          holidayInfo || {
            id: '',
            description: '',
            holidayDate: '',
          }
        }
        validationSchema={Yup.object({
          description: Yup.string().required(' enter event  '),
          holidayDate: Yup.date().required('select date   '),
        })}
        onSubmit={async (values, { resetForm }) => {
          if (values.id) {
            const status = await dispatch(
              updateHoliday({
                ...values,
                declaredBy: userDetails.userName,
              }),
            ).unwrap();
            if (status === 200) {
              resetForm();
              setHolidayInfo(null);
              getHolidays();
            } else {
              alert('Error in Updation');
            }
          } else {
            const response = await dispatch(
              postHoliday({
                description: values.description,
                holidayDate: values.holidayDate,
                declaredBy: userDetails.userName,
              }),
            ).unwrap();
            if (response) {
              resetForm();
              setHolidayInfo(null);
              getHolidays();
            }
          }
        }}
      >
        {({ values }) => (
          <Form className=' border-gray-300  p-2 md:p-4 rounded-md  mt-8'>
            <Typography variant='h6' className='mb-2 text-blue-700'>
              Check Holidays Here !
            </Typography>
            <div className='flex  w-full flex-wrap  gap-2   my-4 rounded-lg items-start '>
              <div className='max-w-72 w-full'>
                <style>
                  {`
                     .react-datepicker__navigation {
                    display: none !important;}
                    .react-datepicker__current-month {
                    display: none !important;
                        }`}
                </style>
                <Field name='holidayDate'>
                  {({ field, form }) => (
                    <DatePicker
                      selected={field.value ? new Date(field.value) : null}
                      onChange={(val) => {
                        if (val instanceof Date && !isNaN(val)) {
                          // Fix timezone offset issue by subtracting the timezone offset in ms
                          const correctedDate = new Date(
                            val.getTime() - val.getTimezoneOffset() * 60000,
                          );

                          form.setFieldValue(
                            field.name,
                            correctedDate.toISOString().split('T')[0],
                          );
                        } else {
                          form.setFieldValue(field.name, null);
                        }
                      }}
                      onCalendarClose={() =>
                        setTimeout(() => {
                          form.setFieldTouched(field.name, true, true);
                        }, 0)
                      }
                      placeholderText='DD-MM-YYYY'
                      dateFormat='dd/MM/yyyy'
                      isClearable={!!field.value}
                      showMonthDropdown
                      showYearDropdown
                      scrollableYearDropdown
                      yearDropdownItemNumber={51} // 1980 → 2030 inclusive
                      dropdownMode='scroll'
                      minDate={new Date(1980, 0, 1)}
                      maxDate={new Date(2050, 11, 31)}
                      wrapperClassName='w-full bg-white'
                      autoComplete='off'
                      customInput={
                        <TextField
                          fullWidth
                          label='Holiday Date'
                          size='small'
                          InputLabelProps={{ shrink: true }}
                          className='w-full'
                        />
                      }
                      className='w-full'
                    />
                  )}
                </Field>
                <ErrorMessage
                  name='holidayDate'
                  component='div'
                  className='text-red-500'
                ></ErrorMessage>
              </div>

              <div className='max-w-72 w-full'>
                <Field
                  as={TextField}
                  size='small'
                  name='description'
                  InputLabelProps={{ shrink: true }}
                  label='Event'
                  placeholder='Enter Your Text Here'
                  className='bg-white  w-full'
                ></Field>
                <ErrorMessage
                  name='description'
                  component='div'
                  className='text-red-500 '
                ></ErrorMessage>
              </div>

              <Button
                type='submit'
                variant='contained'
                disabled={!(!!values.description && !!values.holidayDate)}
                className='h-10'
              >
                Submit
              </Button>
            </div>
          </Form>
        )}
      </Formik>

      <div className='overflow-auto'>
        <div className=' mt-2 rounded min-h-[380px] min-w-[610px]'>
          <DataGrid
            sx={{
              '.MuiDataGrid-row.Mui-selected': {
                backgroundColor: '#fafafa !important', // remove blue background
              },
              '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
                outline: 'none',
                '& .MuiDataGrid-row:hover': {
                  backgroundColor: '#f5f5f5',
                },
              },
              ' .MuiDataGrid-columnHeader': {
                backgroundColor: '#f7f3f0',
                position: 'sticky',
                top: 0,
                zIndex: 10,
              },
              '.MuiDataGrid-virtualScroller': {
                maxHeight: '350px',
                overflow: 'auto',
              },
              height: '440px',
            }}
            rows={(holidays || [])
              .slice()
              .sort(
                (a, b) => new Date(a?.holidayDate) - new Date(b?.holidayDate),
              )}
            columns={columns}
            hideFooter={true}
            disableColumnMenu
          />
        </div>
      </div>
    </>
  );
};
export default React.memo(HolidaysPage);
